/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { ITumor } from 'app/shared/model/tumor.model';

export interface ITumorMeasurement {
  id?: string;
  incidentDate?: number;
  measurementValue?: string;
  measurementUnit?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  measurementName?: IClinicalDictionary | null;
  tumor?: ITumor | null;
}

export const defaultValue: Readonly<ITumorMeasurement> = {
  active: false,
};
